import { render, staticRenderFns } from "./list_zfcg.vue?vue&type=template&id=8f233964&scoped=true"
import script from "./list_zfcg.vue?vue&type=script&lang=js"
export * from "./list_zfcg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f233964",
  null
  
)

export default component.exports